import Avatar from '@Atom/Avatar'
import DoodleGradientCard from '@Atom/DoodleGradientCard'
import Icon from '@Atom/Icon'
import TransparentSearchbar from '@Atom/TransparentSearchbar'
import { decryptStorageData } from '@Helpers/encryptDecrypt'
import Footer from '@Molecule/Footer'
import Table from '@Molecule/Table'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Styles from './style.module.scss'
import useWindowSize from '@Hooks/useWindowSize'

export default function AdminInstructorLayout() {
  const user = decryptStorageData('user', localStorage)
  const navigate = useNavigate()
  const [searchTerm, setSearchTerm] = useState('')
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(5)

  const {width} =useWindowSize()


  const template = useMemo(() => {
    return {
      data: [
        {
          id: 1,
          name: 'Albert Flores',
          profilePicture: '',
          email: 'albertflores@example.com',
          phoneNumber: '082379127923'
        },
        {
          id: 2,
          name: 'Albert Flores',
          profilePicture: '',
          email: 'albertflores@example.com',
          phoneNumber: '082379127923'
        },
        {
          id: 3,
          name: 'Albert Flores',
          profilePicture: '',
          email: 'albertflores@example.com',
          phoneNumber: '082379127923'
        },
        {
          id: 4,
          name: 'Albert Flores',
          profilePicture: '',
          email: 'albertflores@example.com',
          phoneNumber: '082379127923'
        },
        {
          id: 5,
          name: 'Albert Flores',
          profilePicture: '',
          email: 'albertflores@example.com',
          phoneNumber: '082379127923'
        },
      ],
      columns: [
        {
          name: '',
          title: 'Nama Instruktur',
          width: width > 768 ? '455px' : '200px',
          renderData: (row) => (
            <div className={Styles.instructor}>
              <Avatar
                imgUrl={row?.profilePicture}
                iconName='user'
                iconSize='12px'
                size='24px'
              />
              <span>{row?.name}</span>
            </div>
          )
        },
        {
          name: 'email',
          title: 'Email',
          hideOnMobile: true,
        },
        {
          name: 'phoneNumber',
          title: 'Nomor HP',
          hideOnMobile: true,
        }
      ]
    }
  }, [width])


  return (
    <div className={Styles.container}>
      <div className={Styles.wrapper}>
        <DoodleGradientCard className={Styles.header}>
          <div className={Styles.title}>
            <h3>Selamat datang {<span>{user?.name}</span>}</h3>
            <span>Berikut adalah daftar seluruh instruktur di Skills.id</span>
            <TransparentSearchbar
              value={searchTerm}
              setValue={setSearchTerm}
              placeholder='Cari kelasmu'
            />
          </div>
          <button onClick={() => navigate('new')}>
            <Icon icon={'plus'} size={10} />
            <span>Tambah Instruktur</span>
          </button>
        </DoodleGradientCard>
        <Table
          data={template?.data}
          totalData={template?.data?.length}
          totalPage={1}
          columns={template?.columns}
          page={page}
          setPage={setPage}
          className={`${Styles.table} ${!template?.data?.length ? Styles.grow : ''}`}
          limit={limit}
          setLimit={setLimit}
          expandComponent={(row) => (
            <div className={Styles.expandedInfo}>
              <div className={Styles.infoRow}>
                <span>Email</span>
                <span>{row?.email}</span>
              </div>
              <div className={Styles.infoRow}>
                <span>No. Telepon</span>
                <span>{row?.phoneNumber}</span>
              </div>
            </div>
          )}
        />
      </div>

      <Footer />
    </div>
  )
}